var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHam({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 31,
    viewBox: "0 0 46 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 95)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 46,
    height: 5,
    rx: 2.5,
    transform: "translate(250 -95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 46,
    height: 5,
    rx: 2.5,
    transform: "translate(250 -82)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 46,
    height: 5,
    rx: 2.5,
    transform: "translate(250 -69)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHam);
export default __webpack_public_path__ + "static/media/ham.5713fd2e9e9c05cdd7a468ce35ae5544.svg";
export { ForwardRef as ReactComponent };